import { render } from "./NotesPage.vue?vue&type=template&id=5bd3fd81&scoped=true"
import script from "./NotesPage.vue?vue&type=script&lang=js"
export * from "./NotesPage.vue?vue&type=script&lang=js"

import "./NotesPage.vue?vue&type=style&index=0&id=5bd3fd81&scoped=true&lang=css"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd3fd81"]])

export default __exports__